export default {
    sessionDetails: null,
    sessionToken : null,
    testToken: null,
    templateFormat: {
        name: null,
        id: null,
        pageWidth: null,
        pageHeight: null,
        pageBleed: null
    },
    project: {
        name: null,
        id: null,
        templateFormatId: null,
        pages: null
    },
    gallery: [],
    currentPage: 'default_page',
    currentPageIndex: 0,
    currentTab: 'ThemeTab',
    webPageSize: {
        px: {
            width: null,
            height: null
        },
        mm: {
            width: null,
            height: null
        },
        hasValue: false,
        ratio: null
    },
    pageSize: {
        width: null,
        height: null
    },
    activeElement: {},
    elementsVisible: false,
    fonts: [
        {
            family: 'Abril Fatface',
            generic: 'cursive',
            weights: [
                {
                    name: 'Regular',
                    value: 400,
                    style: 'normal'
                }
            ],
            fontHref: `https://fonts.googleapis.com/css2?family=Abril+Fatface&display=swap`
        },
        {
            family: 'Anton',
            generic: 'sans-serif',
            weights: [
                {
                    name: 'Regular',
                    value: 400,
                    style: 'normal'
                }
            ],
            fontHref: `https://fonts.googleapis.com/css2?family=Anton&display=swap`
        },
        {
            family: 'Calistoga',
            generic: 'cursive',
            weights: [
                {
                    name: 'Regular',
                    value: 400,
                    style: 'normal'
                }
            ],
            fontHref: `https://fonts.googleapis.com/css?family=Calistoga&display=swap&subset=latin-ext`
        },
        {
            family: 'Fira Sans',
            generic: 'sans-serif',
            weights: [
                // {
                //     name: 'Extra Light',
                //     value: 200,
                //     style: 'normal'
                // },
                // {
                //     name: 'Extra Light Italic',
                //     value: 200,
                //     style: 'italic'
                // },
                {
                    name: 'Light',
                    value: 300,
                    style: 'normal'
                },
                {
                    name: 'Light Italic',
                    value: 300,
                    style: 'italic'
                },
                {
                    name: 'Regular',
                    value: 400,
                    style: 'normal'
                },
                {
                    name: 'Italic',
                    value: 400,
                    style: 'italic'
                },
                {
                    name: 'Semi Bold',
                    value: 600,
                    style: 'normal'
                },
                {
                    name: 'Semi Bold Italic',
                    value: 600,
                    style: 'italic'
                },
                {
                    name: 'Bold',
                    value: 700,
                    style: 'normal'
                },
                {
                    name: 'Bold Italic',
                    value: 700,
                    style: 'italic'
                },
                // {
                //     name: 'Extra Bold',
                //     value: 800,
                //     style: 'normal'
                // },
                // {
                //     name: 'Extra Bold Italic',
                //     value: 800,
                //     style: 'italic'
                // },
                // {
                //     name: 'Black',
                //     value: 900,
                //     style: 'normal'
                // },
                // {
                //     name: 'Black Italic',
                //     value: 900,
                //     style: 'italic'
                // }
            ],
            fontHref: `https://fonts.googleapis.com/css2?family=Fira+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap`
        },
        {
            family: 'Fjalla One',
            generic: 'sans-serif',
            weights: [
                {
                    name: 'Regular',
                    value: 400,
                    style: 'normal'
                }
            ],
            fontHref: `https://fonts.googleapis.com/css2?family=Fjalla+One&display=swap`
        },
        {
            family: 'Inconsolata',
            generic: 'monospace',
            weights: [
                // {
                //     name: 'Extra Light',
                //     value: 200,
                //     style: 'normal'
                // },
                {
                    name: 'Light',
                    value: 300,
                    style: 'normal'
                },
                {
                    name: 'Regular',
                    value: 400,
                    style: 'normal'
                },
                {
                    name: 'Medium',
                    value: 500,
                    style: 'normal'
                },
                {
                    name: 'Semi Bold',
                    value: 600,
                    style: 'normal'
                },
                {
                    name: 'Bold',
                    value: 700,
                    style: 'normal'
                },
                // {
                //     name: 'Extra Bold',
                //     value: 800,
                //     style: 'normal'
                // },
                // {
                //     name: 'Black',
                //     value: 900,
                //     style: 'normal'
                // }
            ],
            fontHref: `https://fonts.googleapis.com/css2?family=Inconsolata:wght@200;300;400;500;600;700;800;900&display=swap`
        },
        {
            family: 'Indie Flower',
            generic: 'cursive',
            weights: [
                {
                    name: 'Regular',
                    value: 400,
                    style: 'normal'
                }
            ],
            fontHref: `https://fonts.googleapis.com/css2?family=Indie+Flower&display=swap`
        },
        {
            family: 'Josefin Sans',
            generic: 'sans-serif',
            weights: [
                // {
                //     name: 'Thin',
                //     value: 100,
                //     style: 'normal'
                // },
                // {
                //     name: 'Thin Italic',
                //     value: 100,
                //     style: 'italic'
                // },
                // {
                //     name: 'Extra Light',
                //     value: 200,
                //     style: 'normal'
                // },
                // {
                //     name: 'Extra Light Italic',
                //     value: 200,
                //     style: 'italic'
                // },
                {
                    name: 'Light',
                    value: 300,
                    style: 'normal'
                },
                {
                    name: 'Light Italic',
                    value: 300,
                    style: 'italic'
                },
                {
                    name: 'Regular',
                    value: 400,
                    style: 'normal'
                },
                {
                    name: 'Italic',
                    value: 400,
                    style: 'italic'
                },
                {
                    name: 'Medium',
                    value: 500,
                    style: 'normal'
                },
                {
                    name: 'Medium Italic',
                    value: 500,
                    style: 'italic'
                },
                {
                    name: 'Semi Bold',
                    value: 600,
                    style: 'normal'
                },
                {
                    name: 'Semi Bold Italic',
                    value: 600,
                    style: 'italic'
                },
                {
                    name: 'Bold',
                    value: 700,
                    style: 'normal'
                },
                {
                    name: 'Bold Italic',
                    value: 700,
                    style: 'italic'
                }
            ],
            fontHref: `https://fonts.googleapis.com/css2?family=Josefin+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;1,100;1,200;1,300;1,400;1,500;1,600;1,700&display=swap`
        },
        {
            family: 'Lato',
            generic: 'sans-serif',
            weights: [
                // {
                //     name: 'Thin',
                //     value: 100,
                //     style: 'normal'
                // },
                // {
                //     name: 'Thin Italic',
                //     value: 100,
                //     style: 'italic'
                // },
                {
                    name: 'Light',
                    value: 300,
                    style: 'normal'
                },
                {
                    name: 'Light Italic',
                    value: 300,
                    style: 'italic'
                },
                {
                    name: 'Regular',
                    value: 400,
                    style: 'normal'
                },
                {
                    name: 'Italic',
                    value: 400,
                    style: 'italic'
                },
                {
                    name: 'Bold',
                    value: 700,
                    style: 'normal'
                },
                {
                    name: 'Bold Italic',
                    value: 700,
                    style: 'italic'
                },
                // {
                //     name: 'Black',
                //     value: 900,
                //     style: 'normal'
                // },
                // {
                //     name: 'Black Italic',
                //     value: 900,
                //     style: 'italic'
                // }
            ],
            fontHref: `https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap`
        },
        {
            family: 'Lobster',
            generic: 'cursive',
            weights: [
                {
                    name: 'Regular',
                    value: 400,
                    style: 'normal'
                }
            ],
            fontHref: `https://fonts.googleapis.com/css2?family=Lobster&display=swap`
        },
        {
            family: 'Lora',
            generic: 'serif',
            weights: [
                {
                    name: 'Regular',
                    value: 400,
                    style: 'normal'
                },
                {
                    name: 'Italic',
                    value: 400,
                    style: 'italic'
                },
                {
                    name: 'Medium',
                    value: 500,
                    style: 'normal'
                },
                {
                    name: 'Medium Italic',
                    value: 500,
                    style: 'italic'
                },
                {
                    name: 'Semi bold',
                    value: 600,
                    style: 'normal'
                },
                {
                    name: 'Semi bold Italic',
                    value: 600,
                    style: 'italic'
                },
                {
                    name: 'Bold',
                    value: 700,
                    style: 'normal'
                },
                {
                    name: 'Bold Italic',
                    value: 700,
                    style: 'italic'
                }
            ],
            fontHref: `https://fonts.googleapis.com/css2?family=Lora:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500;1,600;1,700&display=swap`
        },
        {
            family: 'Merriweather',
            generic: 'serif',
            weights: [
                {
                    name: 'Light',
                    value: 300,
                    style: 'normal'
                },
                {
                    name: 'Light Italic',
                    value: 300,
                    style: 'italic'
                },
                {
                    name: 'Regular',
                    value: 400,
                    style: 'normal'
                },
                {
                    name: 'Italic',
                    value: 400,
                    style: 'italic'
                },
                {
                    name: 'Bold',
                    value: 700,
                    style: 'normal'
                },
                {
                    name: 'Bold Italic',
                    value: 700,
                    style: 'italic'
                },
                // {
                //     name: 'Black',
                //     value: 900,
                //     style: 'normal'
                // },
                // {
                //     name: 'Black Italic',
                //     value: 900,
                //     style: 'italic'
                // }
            ],
            fontHref: `https://fonts.googleapis.com/css2?family=Merriweather:ital,wght@0,300;0,400;0,700;0,900;1,300;1,400;1,700;1,900&display=swap`
        },
        {
            family: 'Montserrat',
            generic: 'sans-serif',
            weights: [
                // {
                //     name: 'Extra Light',
                //     value: 200,
                //     style: 'normal'
                // },
                // {
                //     name: 'Extra Light Italic',
                //     value: 200,
                //     style: 'italic'
                // },
                {
                    name: 'Light',
                    value: 300,
                    style: 'normal'
                },
                {
                    name: 'Light Italic',
                    value: 300,
                    style: 'italic'
                },
                {
                    name: 'Regular',
                    value: 400,
                    style: 'normal'
                },
                {
                    name: 'Italic',
                    value: 400,
                    style: 'italic'
                },
                {
                    name: 'Medium',
                    value: 500,
                    style: 'normal'
                },
                {
                    name: 'Medium Italic',
                    value: 500,
                    style: 'italic'
                },
                {
                    name: 'Semi Bold',
                    value: 600,
                    style: 'normal'
                },
                {
                    name: 'Semi Bold Italic',
                    value: 600,
                    style: 'italic'
                },
                {
                    name: 'Bold',
                    value: 700,
                    style: 'normal'
                },
                {
                    name: 'Bold Italic',
                    value: 700,
                    style: 'italic'
                },
                // {
                //     name: 'Extra Bold',
                //     value: 800,
                //     style: 'normal'
                // },
                // {
                //     name: 'Extra Bold Italic',
                //     value: 800,
                //     style: 'italic'
                // },
                // {
                //     name: 'Black',
                //     value: 900,
                //     style: 'normal'
                // },
                // {
                //     name: 'Black Italic',
                //     value: 900,
                //     style: 'italic'
                // }
            ],
            fontHref: `https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap`
        },
        {
            family: 'Muli',
            generic: 'sans-serif',
            weights: [
                // {
                //     name: 'Extra Light',
                //     value: 200,
                //     style: 'normal'
                // },
                // {
                //     name: 'Extra Light Italic',
                //     value: 200,
                //     style: 'italic'
                // },
                {
                    name: 'Light',
                    value: 300,
                    style: 'normal'
                },
                {
                    name: 'Light Italic',
                    value: 300,
                    style: 'italic'
                },
                {
                    name: 'Regular',
                    value: 400,
                    style: 'normal'
                },
                {
                    name: 'Italic',
                    value: 400,
                    style: 'italic'
                },
                {
                    name: 'Medium',
                    value: 500,
                    style: 'normal'
                },
                {
                    name: 'Medium Italic',
                    value: 500,
                    style: 'italic'
                },
                {
                    name: 'Semi Bold',
                    value: 600,
                    style: 'normal'
                },
                {
                    name: 'Semi Bold Italic',
                    value: 600,
                    style: 'italic'
                },
                {
                    name: 'Bold',
                    value: 700,
                    style: 'normal'
                },
                {
                    name: 'Bold Italic',
                    value: 700,
                    style: 'italic'
                },
                // {
                //     name: 'Extra Bold',
                //     value: 800,
                //     style: 'normal'
                // },
                // {
                //     name: 'Extra Bold Italic',
                //     value: 800,
                //     style: 'italic'
                // },
                // {
                //     name: 'Black Bold',
                //     value: 900,
                //     style: 'normal'
                // },
                // {
                //     name: 'Black Italic',
                //     value: 900,
                //     style: 'italic'
                // }
            ],
            fontHref: `https://fonts.googleapis.com/css2?family=Muli:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap`
        },
        {
            family: 'Noto Sans',
            generic: 'sans-serif',
            weights: [
                {
                    name: 'Regular',
                    value: 400,
                    style: 'normal'
                },
                {
                    name: 'Italic',
                    value: 400,
                    style: 'italic'
                },
                {
                    name: 'Bold',
                    value: 700,
                    style: 'normal'
                },
                {
                    name: 'Bold Italic',
                    value: 700,
                    style: 'italic'
                }
            ],
            fontHref: `https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,400;0,700;1,400;1,700&display=swap`
        },
        {
            family: 'Nunito',
            generic: 'sans-serif',
            weights: [
                // {
                //     name: 'Extra Light',
                //     value: 200,
                //     style: 'normal'
                // },
                // {
                //     name: 'Extra /light Italic',
                //     value: 200,
                //     style: 'italic'
                // },
                {
                    name: 'Light',
                    value: 300,
                    style: 'normal'
                },
                {
                    name: 'Light Italic',
                    value: 300,
                    style: 'italic'
                },
                {
                    name: 'Regular',
                    value: 400,
                    style: 'normal'
                },
                {
                    name: 'Italic',
                    value: 400,
                    style: 'italic'
                },
                {
                    name: 'Semi Bold',
                    value: 600,
                    style: 'normal'
                },
                {
                    name: 'Semi Bold Italic',
                    value: 600,
                    style: 'italic'
                },
                {
                    name: 'Bold',
                    value: 700,
                    style: 'normal'
                },
                {
                    name: 'Bold Italic',
                    value: 700,
                    style: 'italic'
                },
                // {
                //     name: 'Extra Bold',
                //     value: 800,
                //     style: 'normal'
                // },
                // {
                //     name: 'Extra Bold Italic',
                //     value: 800,
                //     style: 'italic'
                // },
                // {
                //     name: 'Black',
                //     value: 900,
                //     style: 'normal'
                // },
                // {
                //     name: 'Black Italic',
                //     value: 900,
                //     style: 'italic'
                // }
            ],
            fontHref: `https://fonts.googleapis.com/css?family=Nunito:200,200i,300,300i,400,400i,600,600i,700,700i,800,800i,900,900i&display=swap&subset=latin-ext`
        },
        {
            family: 'Open Sans',
            generic: 'sans-serif',
            weights: [
                {
                    name: 'Light',
                    value: 300,
                    style: 'normal'
                },
                {
                    name: 'Light Italic',
                    value: 300,
                    style: 'italic'
                },
                {
                    name: 'Regular',
                    value: 400,
                    style: 'normal'
                },
                {
                    name: 'Italic',
                    value: 400,
                    style: 'italic'
                },
                {
                    name: 'Semi Bold',
                    value: 600,
                    style: 'normal'
                },
                {
                    name: 'Semi Bold Italic',
                    value: 600,
                    style: 'italic'
                },
                {
                    name: 'Bold',
                    value: 700,
                    style: 'normal'
                },
                {
                    name: 'Bold Italic',
                    value: 700,
                    style: 'italic'
                },
                // {
                //     name: 'Extra Bold',
                //     value: 800,
                //     style: 'normal'
                // },
                // {
                //     name: 'Extra Bold Italic',
                //     value: 800,
                //     style: 'italic'
                // }
            ],
            fontHref: `https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,600;0,700;0,800;1,300;1,400;1,600;1,700;1,800&display=swap`
        },
        {
            family: 'Oswald',
            generic: 'sans-serif',
            weights: [
                // {
                //     name: 'Extra Light',
                //     value: 200,
                //     style: 'normal'
                // },
                {
                    name: 'Light',
                    value: 300,
                    style: 'normal'
                },
                {
                    name: 'Regular',
                    value: 400,
                    style: 'normal'
                },
                {
                    name: 'Medium',
                    value: 500,
                    style: 'normal'
                },
                {
                    name: 'Semi Bold',
                    value: 600,
                    style: 'normal'
                },
                {
                    name: 'Bold',
                    value: 700,
                    style: 'normal'
                }
            ],
            fontHref: `https://fonts.googleapis.com/css2?family=Oswald:wght@200;300;400;500;600;700&display=swap`
        },
        {
            family: 'Pacifico',
            generic: 'cursive',
            weights: [
                {
                    name: 'Regular',
                    value: 400,
                    style: 'normal'
                }
            ],
            fontHref: `https://fonts.googleapis.com/css?family=Pacifico&display=swap&subset=latin-ext`
        },
        {
            family: 'Quicksand',
            generic: 'sans-serif',
            weights: [
                {
                    name: 'Light',
                    value: 300,
                    style: 'normal'
                },
                {
                    name: 'Regular',
                    value: 400,
                    style: 'normal'
                },
                {
                    name: 'Medium',
                    value: 500,
                    style: 'normal'
                },
                {
                    name: 'Semi Bold',
                    value: 600,
                    style: 'normal'
                },
                {
                    name: 'Bold',
                    value: 700,
                    style: 'normal'
                }
            ],
            fontHref: `https://fonts.googleapis.com/css2?family=Quicksand:wght@300;400;500;600;700&display=swap`
        },
        {
            family: 'Raleway',
            generic: 'sans-serif',
            weights: [
                // {
                //     name: 'Thin',
                //     value: 100,
                //     style: 'normal'
                // },
                // {
                //     name: 'Thin Italic',
                //     value: 100,
                //     style: 'italic'
                // },
                // {
                //     name: 'Extra light',
                //     value: 200,
                //     style: 'normal'
                // },
                // {
                //     name: 'Extra Light Italic',
                //     value: 200,
                //     style: 'italic'
                // },
                {
                    name: 'Light',
                    value: 300,
                    style: 'normal'
                },
                {
                    name: 'Light Italic',
                    value: 300,
                    style: 'italic'
                },
                {
                    name: 'Regular',
                    value: 400,
                    style: 'normal'
                },
                {
                    name: 'Italic',
                    value: 400,
                    style: 'italic'
                },
                {
                    name: 'Medium',
                    value: 500,
                    style: 'normal'
                },
                {
                    name: 'Medium Italic',
                    value: 500,
                    style: 'italic'
                },
                {
                    name: 'Semi Bold',
                    value: 600,
                    style: 'normal'
                },
                {
                    name: 'Semi Bold Italic',
                    value: 600,
                    style: 'italic'
                },
                {
                    name: 'Bold',
                    value: 700,
                    style: 'normal'
                },
                {
                    name: 'Bold Italic',
                    value: 700,
                    style: 'italic'
                },
                // {
                //     name: 'Extra Bold',
                //     value: 800,
                //     style: 'normal'
                // },
                // {
                //     name: 'Extra Bold Italic',
                //     value: 800,
                //     style: 'italic'
                // },
                // {
                //     name: 'Black',
                //     value: 900,
                //     style: 'normal'
                // },
                // {
                //     name: 'Black Italic',
                //     value: 900,
                //     style: 'italic'
                // }
            ],
            fontHref: `https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap`
        },
        {
            family: 'Roboto',
            generic: 'sans-serif',
            weights: [
                // {
                //     name: 'Thin',
                //     value: 100,
                //     style: 'normal'
                // },
                // {
                //     name: 'Thin Italic',
                //     value: 100,
                //     style: 'italic'
                // },
                {
                    name: 'Light',
                    value: 300,
                    style: 'normal'
                },
                {
                    name: 'Light Italic',
                    value: 300,
                    style: 'italic'
                },
                {
                    name: 'Regular',
                    value: 400,
                    style: 'normal'
                },
                {
                    name: 'Italic',
                    value: 400,
                    style: 'italic'
                },
                {
                    name: 'Medium',
                    value: 500,
                    style: 'normal'
                },
                {
                    name: 'Medium Italic',
                    value: 500,
                    style: 'italic'
                },
                {
                    name: 'Bold',
                    value: 700,
                    style: 'normal'
                },
                {
                    name: 'Bold Italic',
                    value: 700,
                    style: 'italic'
                },
                // {
                //     name: 'Black',
                //     value: 900,
                //     style: 'normal'
                // },
                // {
                //     name: 'Black Italic',
                //     value: 900,
                //     style: 'italic'
                // }
            ],
            fontHref: `https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap`
        },
        {
            family: 'Roboto Slab',
            generic: 'serif',
            weights: [
                // {
                //     name: 'Thin',
                //     value: 100,
                //     style: 'normal'
                // },
                // {
                //     name: 'Extra Light',
                //     value: 200,
                //     style: 'normal'
                // },
                {
                    name: 'Light',
                    value: 300,
                    style: 'normal'
                },
                {
                    name: 'Regular',
                    value: 400,
                    style: 'normal'
                },
                {
                    name: 'Medium',
                    value: 500,
                    style: 'normal'
                },
                {
                    name: 'Semi Bold',
                    value: 600,
                    style: 'normal'
                },
                {
                    name: 'Bold',
                    value: 700,
                    style: 'normal'
                },
                // {
                //     name: 'Extra Bold',
                //     value: 800,
                //     style: 'normal'
                // },
                // {
                //     name: 'Black',
                //     value: 900,
                //     style: 'normal'
                // }
            ],
            fontHref: `https://fonts.googleapis.com/css2?family=Roboto+Slab:wght@100;200;300;400;500;600;700;800;900&display=swap`
        },
        {
            family: 'Titillium Web',
            generic: 'sans-serif',
            weights: [
                // {
                //     name: 'Extra Light',
                //     value: 200,
                //     style: 'normal'
                // },
                // {
                //     name: 'Extra Light Italic',
                //     value: 200,
                //     style: 'italic'
                // },
                {
                    name: 'Light',
                    value: 300,
                    style: 'normal'
                },
                {
                    name: 'Light Italic',
                    value: 300,
                    style: 'italic'
                },
                {
                    name: 'Regular',
                    value: 400,
                    style: 'normal'
                },
                {
                    name: 'Italic',
                    value: 400,
                    style: 'italic'
                },
                {
                    name: 'Semi Bold',
                    value: 600,
                    style: 'normal'
                },
                {
                    name: 'Semi Bold Italic',
                    value: 600,
                    style: 'italic'
                },
                {
                    name: 'Bold',
                    value: 700,
                    style: 'normal'
                },
                {
                    name: 'Bold Italic',
                    value: 700,
                    style: 'italic'
                },
                // {
                //     name: 'Black',
                //     value: 900,
                //     style: 'normal'
                // }
            ],
            fontHref: `https://fonts.googleapis.com/css2?family=Titillium+Web:ital,wght@0,200;0,300;0,400;0,600;0,700;0,900;1,200;1,300;1,400;1,600;1,700&display=swap`
        }
    ],
    lastUsedColors: [],
    activeThemeTab: 'activeFormatProjects',
    activeProjectInThemeTab: null,
    activeFormatInThemeTab: {},
    productValues: [],
    pageTransition: 0,
    placeholderUserInputs: null,
    placeholders: [],
    hiddenTabs: {
        themeTab: false,
        imageTab: false,
        photoCellTab: false,
        textTab: false,
        shapeTab: false,
        placeholderTab: false
    },
    allElementsLoaded: false,
    elementsChanging: false
}